$(document).ready(function(){
  $('.centermode').slick({
    centerMode: true,
    centerPadding: '22%',
    dots: true,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000, // 3 seconds
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '10%',
          slidesToShow: 1
        }
      },
     
    ]
  });
  
//  $('.tabresponsive').slick({
//   dots: false,
//   infinite: false,
//   arrows: true,
//    prevArrow: `<button type="button" class="slick-prev pull-left">
//     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//       <path d="M14 8.00004H2M2 8.00004L7.66667 2.33337M2 8.00004L7.66667 13.6667" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//     </svg>
//   </button>`,
//   nextArrow: `<button type="button" class="slick-next pull-right">
//     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//       <path d="M2 7.99996L14 7.99996M14 7.99996L8.33333 13.6666M14 7.99996L8.33333 2.33329" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
//     </svg>
//   </button>`,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1023,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
  $(".facets__item").click(function(event){
   event.preventDefault();
})
});

 document.dispatchEvent(new 
CustomEvent("swym:collections-loaded"));

  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab-title");
    const contents = document.querySelectorAll(".tab-content");

    // Initialize slick ONLY for the first (active) tab
    const firstActiveTab = document.querySelector(".tab-content.active .tabresponsive");
    if (firstActiveTab && !$(firstActiveTab).hasClass('slick-initialized')) {
      $(firstActiveTab).slick({
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: `<button type="button" class="slick-prev pull-left">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14 8.00004H2M2 8.00004L7.66667 2.33337M2 8.00004L7.66667 13.6667" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>`,
        nextArrow: `<button type="button" class="slick-next pull-right">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2 7.99996L14 7.99996M14 7.99996L8.33333 13.6666M14 7.99996L8.33333 2.33329" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>`,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        const target = this.getAttribute("data-tab");

        tabs.forEach((t) => t.classList.remove("active"));
        this.classList.add("active");

        contents.forEach((c) => {
          const isTarget = c.getAttribute("data-tab") === target;
          c.classList.toggle("active", isTarget);

          if (isTarget) {
            const slickSlider = $(c).find('.tabresponsive');
            if (!slickSlider.hasClass('slick-initialized')) {
              slickSlider.slick({
                dots: false,
                infinite: false,
                arrows: true,
                prevArrow: `<button type="button" class="slick-prev pull-left">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M14 8.00004H2M2 8.00004L7.66667 2.33337M2 8.00004L7.66667 13.6667" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>`,
                nextArrow: `<button type="button" class="slick-next pull-right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2 7.99996L14 7.99996M14 7.99996L8.33333 13.6666M14 7.99996L8.33333 2.33329" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>`,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 1023,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              });
            } else {
              slickSlider.slick('setPosition');
            }
          }
        });
      });
    });
  });


